<style lang="scss" scoped>

    #sidebar{
        width: 400px;
        position: fixed;
        top: 0;
        right: 0;
        height: 100vh;
        z-index: 999;
        transition: all .3s;
        border:0;
        z-index: 9999;
        display:flex;
        flex-direction: column;
        right: -130%;
        transition: all 600ms;

        .content{
            z-index:10;
            background:#e2dcd4;

            .btn-primary{

                &:after{
                    background: linear-gradient(270deg, rgba(238, 233, 229, 0) 0%, #e2dcd4 100%);
                }

            }

        }

        .background-obfuscator{
            position:fixed;
            left:0px;
            top:0;
            width: calc(100%);
            height:100%;
            background:rgba(0, 0, 0, 0.5);
            z-index:-1;
            opacity: 0;
            transition: all 600ms;
            pointer-events: none;
        }

        &.appear{
            right:0;
            transition: all 600ms;

            .background-obfuscator{
                pointer-events: all;
                opacity:1;
                transition: all 600ms;
            }

        }

        .free-shipping{
            position: relative;
            width: 100%;
        }

    }

</style>

<template>
    <nav id="sidebar" class="collapse show side-menu bg-beige" :class="show ? 'appear' : ''">
        <div class="h-100 pt-3 pb-4 content">
            <div class="h-100">

                <div class="d-flex flex-column h-100 mt-0">

                    <div class="d-flex w-100 px-4 py-1">
                        <div class="flex-grow-1">
                            <span class="h6 text-primary font-italic">{{$root.translateString('products_in_total')}} ({{countProducts}})</span>
                        </div>
                        <div @click="show = false" class="cursor-pointer close-aside-menu">
                            <img width="17" src="/images/icons/assets-07.svg" alt="chiudi"/>
                        </div>
                    </div>
                    <div class="w-100">
                       <hr>
                    </div>

                    <div class="flex-grow-1 overflow-auto">
                        <div class="pt-3 px-4">
                            <div class="w-100 d-flex product-line mb-3" v-for="(item, key) in cart" :key="key">
                                <img width="62" height="80" class="ml-n2" :src="item.options.image" :alt="item.options.name" />
                                <div class="d-flex flex-column flex-grow-1 pl-4">
                                    <div class="d-flex flex-grow-1 pt-15 w-100">
                                        <span class="pe-2 h-100 text-nowrap">{{item.qty}} x</span>
                                        <span class="flex-grow-1 d-flex flex-column">
                                            <span class="text-uppercase" v-text="item.options.name.replace('<br>', ' ')"></span>
                                            <span class="pt-15" v-if="lang == 'it'">
                                                <span class="w-100 text-grey pt-15" v-if="item.options.type == 'vini'" v-text="item.options.combination"></span>
                                                <span class="w-100 text-grey pt-15" v-else>Marchesi di Barolo</span>
                                            </span>
                                            <span class="pt-15" v-else-if="lang == 'de'">
                                                <span class="w-100 text-grey pt-15" v-if="item.options.type == 'vini'" v-text="item.options.combination.toLowerCase().replace('bottiglia', 'Flasche')"></span>
                                                <span class="w-100 text-grey pt-15" v-else>Marchesi di Barolo</span>
                                            </span>
                                            <span class="pt-15" v-else>
                                                <span class="w-100 text-grey pt-15" v-if="item.options.type == 'vini'" v-text="item.options.combination.toLowerCase().replace('bottiglia', 'Bottle')"></span>
                                                <span class="w-100 text-grey pt-15" v-else>Marchesi di Barolo</span>
                                            </span>
                                        </span>
                                    </div>
                                    <div class="py-0 d-flex flex-grow-1 mt-2 pl-0 align-items-center">
                                        <p class="flex-grow-1 price text-nowrap mb-0">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </p>
                                        <div class="carrello-item__remove-btn">
                                            <a href="javascript:void(0)" @click="updateCart(key, 0)">
                                                <!--<span>{{$root.translateString('remove')}}</span>-->
                                                <img alt="remove" src="/images/icons/trash.svg" width="13"/>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-top border-bottom py-35">
                        <div class="px-4" v-if="missing_for_free_shipping <= 0">
                            <div class="d-flex align-items-center justify-content-center">
                                <div class="d-flex align-items-center justify-content-center img-flex-container">
                                    <img alt="icona" src="/images/icons/assets-01.svg" width="25" class="me-2">
                                </div>
                                <span class="pl-1 h6 mb-0 text-primary">
                                   <span v-if="lang == 'it'">
                                       Hai raggiunto la Spedizione gratuita!
                                    </span>
                                    <span v-else-if="lang == 'de'">
                                       Kostenloser Versand erreicht!
                                    </span>
                                    <span v-else>
                                       You have reached Free Shipping!
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="px-4" v-else>
                            <div class="d-flex align-items-center justify-content-center">
                                <div class="d-flex align-items-center justify-content-center img-flex-container">
                                    <img alt="icona" src="/images/icons/assets-01.svg" width="25" class="me-2">
                                </div>
                                <span class="pl-25 h6 mb-0 text-primary">
                                    <span v-if="lang == 'it'">
                                       Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                                    </span>
                                    <span v-else-if="lang == 'de'">
                                        € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} für den kostenlosen Versand übrig.
                                    </span>
                                    <span v-else>
                                       € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="totals px-4">
                        <div class="line d-flex h6 mt-4 mb-2 text-grey">
                            <span class="flex-grow-1">
                                {{$root.translateString('subtotal')}}
                            </span>
                            <span>
                                € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                            </span>
                        </div>
                        <div class="line d-flex h6 mb-2 text-grey">
                            <span class="flex-grow-1">
                                {{$root.translateString('shipping')}}
                            </span>
                            <span>
                                <span v-if="shipping > 0">
                                 € {{ $root.currencyDisplaySimple(shipping) }}
                                </span>
                                <span v-else>{{$root.translateString('free')}}</span>
                            </span>
                        </div>
                        <div class="line d-flex h6 mb-2 text-grey" v-if="discount > 0">
                            <span class="flex-grow-1">
                                {{$root.translateString('discount')}}
                            </span>
                            <span>
                                € {{ $root.currencyDisplaySimple(discount) }}
                            </span>
                        </div>
                        <div class="line d-flex text-grey py-35 mb-2">
                            <span class="flex-grow-1">
                                <span class="h4 text-dark">{{$root.translateString('total')}}</span>
                                &nbsp;
                                <span class="h6">
                                    <small>({{$root.translateString('tax_included')}})</small>
                                </span>

                            </span>
                            <span>
                                <span class="h4 text-dark">€ {{ $root.currencyDisplaySimple(finalPrice) }}</span>
                            </span>
                        </div>
                        <div class="line d-flex mb-0 text-grey">

                            <a :href="$root.langRoute('/carrello')" class="btn d-inline-flex btn-primary pt-25 pb-35 ps-45 ps-sm-5 pe-45 pe-sm-5 mt-4 mt-sm-0 h-auto h7 text-uppercase w-100">
                                <span class="d-block mx-25 mx-lg-0">
                                    <span class="text-smaller-90 text-md-default-size text-smaller-lg-90 text-smaller-xl-95 text-xl-default-size">{{$root.translateString('go_to_cart')}}</span>
                                </span>
                            </a>

                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="background-obfuscator" @click="show = false"></div>
    </nav>
</template>
<script>
export default {
    props: ['lang', 'freeShippingAt'],
    data() {
        return {
            show:false,
            cartRaw: null,
            priceTotalWt: 0,
            finalPrice: 0,
            shipping: 0,
            discount: 0,
            missing_for_free_shipping: 0,
        }
    },
    mounted() {
        this.getCart();

        this.$eventHub.$on('cart.show', payload => {
            if(vw > 575) {
                this.show = true;
            }
        });

        this.$eventHub.$on('cart.added', payload => {
            this.getCart();
        });

        this.$eventHub.$on('cart.updated', payload => {
            this.getCart();
        });

    },
    methods: {
        emptyCart() {
            axios.post('/api/cart/empty', {})
            .then(response => {
                this.cart = null;
                this.shipping = 0;
                this.priceTotalWt = 0;
                this.finalPrice = 0;
                this.discount = 0;
                this.missing_for_free_shipping = 0;
            })
        },
        updateCart(key, value) {

            axios.post('/api/cart/update', {
                'key': key,
                'qty': value,
            })
            .then(response => {
                this.getCart();

                let update_type = 'add';
                let quantity_to_track = value;

                if(quantity_to_track == 0) {

                    quantity_to_track = this.cart[key].qty;

                    try{
                        gtag('event', 'remove_from_cart', {
                            "items": [
                                {
                                    'name': this.cart[key].options.name,
                                    'id': this.cart[key].id,
                                    'price': this.cart[key].options.price,
                                    'brand': 'Marchesi di Barolo',
                                    'category': this.cart[key].options.type,
                                    'variant': this.cart[key].options.combination.toLowerCase(),
                                    'quantity': quantity_to_track
                                }
                            ]
                        });
                    }catch(e){}

                }else{

                    try{
                        gtag('event', 'add_to_cart', {
                            "items": [
                                {
                                    'name': this.cart[key].name,
                                    'id': this.cart[key].id,
                                    'price': this.cart[key].options.price,
                                    'brand': 'Marchesi di Barolo',
                                    'category': this.cart[key].options.type,
                                    'variant': this.cart[key].options.combination.toLowerCase(),
                                    'quantity': quantity_to_track
                                }
                            ]
                        });
                    }catch(e){}
                }

                this.$eventHub.$emit('cart.updated');
                this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));
            })
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.cartRaw = response.data.cart;
                this.shipping = response.data.shipping;
                this.priceTotalWt = response.data.priceTotalWt;
                this.finalPrice = response.data.finalPrice;
                this.discount = response.data.discount;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;

                if(_.isEmpty(this.cart)) {
                    this.show = false;
                }

            })
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
        this.$eventHub.$off('cart.show');
        this.$eventHub.$off('cart.updated');
        this.$eventHub.$off('cart.updated.simpleQty');
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }
            return tmp;
        },
        countProducts() {

            if(!this.isNotEmpty(this.cart)) {
                return 0;
            }

            let count = 0;

            for (let [key, item] of Object.entries(this.cart)) {
                count += item.qty;
            };

            return count;
        },
    }
}
</script>
